//components
import { SectionWrap, KickerDot } from '../SectionHeading';
import { CountUp } from '../CountUp';

//styles
import {
  ProofSection,
  BigNums,
  BigNum,
  BigNumValue,
  BigNumLabel,
  SectionTitleCustom,
  SectionLedeCustom,
  KickerCustom,
} from './Proof.styles';

export const proofOutcomes = [
  { prefix: 'Up to ', value: 20, suffix: '%', label: 'lower freight cost' },
  { value: 100, suffix: '%', label: 'primary tender acceptance' },
  { value: 90, suffix: ' Days', label: 'to first outcomes' },
];

export function Proof({ outcomes }) {
  return (
    <ProofSection id="proof">
      <SectionWrap>
        <KickerCustom>
          <KickerDot />
          Outcomes
        </KickerCustom>
        <SectionTitleCustom>
          Results you care about, proven by our customers.
        </SectionTitleCustom>
        <SectionLedeCustom>
          Not model outputs or dashboard metrics &mdash; freight moved, costs
          lowered, and acceptance held, on real accounts.
        </SectionLedeCustom>

        <BigNums>
          {outcomes.map((outcome) => (
            <BigNum key={outcome.label}>
              <BigNumValue>
                {outcome.prefix}
                <CountUp value={outcome.value} />
                {outcome.suffix}
              </BigNumValue>
              <BigNumLabel>{outcome.label}</BigNumLabel>
            </BigNum>
          ))}
        </BigNums>
      </SectionWrap>
    </ProofSection>
  );
}
